import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import ScrollToTop from '@/components/ScrollToTop';
import CanonicalUrl from '@/components/CanonicalUrl';
import CookieBanner from '@/components/CookieBanner';
import GoogleAdsTag from '@/components/GoogleAdsTag';
import { VatProvider } from '@/lib/vat';
import HomePage from '@/pages/HomePage';

const BestillPage = lazy(() => import('@/pages/BestillPage'));
const PriserPage = lazy(() => import('@/pages/PriserPage'));
const TjenesterPage = lazy(() => import('@/pages/TjenesterPage'));
const TjenestePrivatPage = lazy(() => import('@/pages/TjenestePrivatPage'));
const TjenesteBedriftPage = lazy(() => import('@/pages/TjenesteBedriftPage'));
const TjenesteRehabPage = lazy(() => import('@/pages/TjenesteRehabPage'));
const TjenesteStorsekkerPage = lazy(() => import('@/pages/TjenesteStorsekkerPage'));
const FraksjonerPage = lazy(() => import('@/pages/FraksjonerPage'));
const UtstyrPage = lazy(() => import('@/pages/UtstyrPage'));
const OmOssPage = lazy(() => import('@/pages/OmOssPage'));
const KunderPage = lazy(() => import('@/pages/KunderPage'));
const MiljoPage = lazy(() => import('@/pages/MiljoPage'));
const NyheterPage = lazy(() => import('@/pages/NyheterPage'));
const KontaktPage = lazy(() => import('@/pages/KontaktPage'));
const VilkarPage = lazy(() => import('@/pages/VilkarPage'));
const PersonvernPage = lazy(() => import('@/pages/PersonvernPage'));
const TilbudPage = lazy(() => import('@/pages/TilbudPage'));
const AdminPage = lazy(() => import('@/pages/AdminPage'));
const NotFoundPage = lazy(() => import('@/pages/NotFoundPage'));

function PageFallback() {
  return <div className="min-h-[60vh]" aria-busy="true" />;
}

export default function App() {
  return (
    <BrowserRouter>
      <VatProvider>
        <ScrollToTop />
        <CanonicalUrl />
        <div className="flex min-h-screen flex-col">
          <Routes>
            <Route path="/admin" element={<Suspense fallback={<PageFallback />}><AdminPage /></Suspense>} />
            <Route path="/admin/endringer" element={<Suspense fallback={<PageFallback />}><AdminPage /></Suspense>} />
            <Route
              path="/*"
              element={(
                <>
                  <Header />
                  <main className="flex-1">
                    <Suspense fallback={<PageFallback />}>
                      <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/bestill" element={<BestillPage />} />
                        <Route path="/priser" element={<PriserPage />} />
                        <Route path="/tjenester" element={<TjenesterPage />} />
                        <Route path="/tjenester/privat" element={<TjenestePrivatPage />} />
                        <Route path="/tjenester/bedrift-borettslag" element={<TjenesteBedriftPage />} />
                        <Route path="/tjenester/rehab-riving" element={<TjenesteRehabPage />} />
                        <Route path="/tjenester/storsekker" element={<TjenesteStorsekkerPage />} />
                        <Route path="/fraksjoner" element={<FraksjonerPage />} />
                        <Route path="/utstyr" element={<UtstyrPage />} />
                        <Route path="/om-oss" element={<OmOssPage />} />
                        <Route path="/kunder" element={<KunderPage />} />
                        <Route path="/miljo" element={<MiljoPage />} />
                        <Route path="/nyheter" element={<NyheterPage />} />
                        <Route path="/kontakt" element={<KontaktPage />} />
                        <Route path="/vilkar" element={<VilkarPage />} />
                        <Route path="/personvern" element={<PersonvernPage />} />
                        <Route path="/tilbud" element={<TilbudPage />} />
                        <Route path="*" element={<NotFoundPage />} />
                      </Routes>
                    </Suspense>
                  </main>
                  <Footer />
                  <CookieBanner />
                  <GoogleAdsTag />
                </>
              )}
            />
          </Routes>
        </div>
      </VatProvider>
    </BrowserRouter>
  );
}
